import React from 'react';
import ReactDOM from 'react-dom/client';
import { TunePage } from './TunePage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { initMonitoring } from '@/lib/monitoring';

initMonitoring('tune');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="Tune Wizard">
      <TunePage />
    </SafeBoundary>
  </React.StrictMode>
);
